import React, { useState } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import { noop } from 'underscore';

import { getDisplayName } from '@bingads-webui-react/hoc-utils';

import { StepCardBaseContainer } from './step-base-container';
import { useStepHandlerContext } from './step-handler-context';

export function withStepHandlers(WrappedComponent) {
  const HOC = (props) => {
    const { baseStepProps, ...restProps } = props;
    const stepHandlers = useStepHandlerContext();
    const {
      goToNextStep,
      goToPreviousStep,
      onCancel,
      showBlocking,
      dismissBlocking,
      showWarningMessage,
      onNextClick,
      nextClicked,
      resetNextClicked,
      onUrlChange = noop,
      onFailed = noop,
    } = stepHandlers;

    const [isInitialized, setIsInitialized] = useState(true);

    return (
      <StepCardBaseContainer
        onNextClick={onNextClick}
        onPreviousClick={goToPreviousStep}
        onCancelClick={onCancel}
        isNextButtonDisabled={!isInitialized}
        {...baseStepProps}
      >
        <WrappedComponent
          setIsInitialized={setIsInitialized}
          showBlocking={showBlocking}
          dismissBlocking={dismissBlocking}
          nextClicked={nextClicked}
          resetNextClicked={resetNextClicked}
          goToNextStep={goToNextStep}
          showWarningMessage={showWarningMessage}
          onUrlChange={onUrlChange}
          onFailed={onFailed}
          {...restProps}
        />
      </StepCardBaseContainer>
    );
  };

  HOC.propTypes = {
    baseStepProps: PropTypes.shape({}),
  };

  HOC.defaultProps = {
    baseStepProps: {},
  };

  HOC.displayName = `withStepHandlers(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
}
